<template>
  <v-row>
    <v-col cols="12" sm="4" align="center">
      <h2>Internal Employee</h2>
      <span class="headline">{{ userName }}</span>
    </v-col>
    <v-col cols="12" sm="4" align="center">
      <h2>Individual Gross Profit</h2>
      <span class="headline">{{ individualGp | currency }}</span>
    </v-col>
    <v-col cols="12" sm="4" align="center">
      <h2>Commission</h2>
      <span class="headline">{{ commissionAmount | currency }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: [
    'userName',
    'commissionAmount',
    'individualGp'
  ]
}
</script>
